module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxlist/inboxlist_icon01_this-a03d62fa0f68af8d709b616ded8c81ba.png";